import "./layout.pcss";
import angular from "angular";
import "angular-i18n/angular-locale_hu-hu";
import "slick-carousel/slick/slick.min";
import "angular-slick-carousel";
import "../../common/common";
import { PubsubReplay } from 'pubsub-replay';
if (!window.ipEventBus) {
	window.ipEventBus = PubsubReplay;
}
const MODULE_NAME = "ANYIT-app";
export default angular.module(MODULE_NAME, window.dependencies).name;

